var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Map } from "../../Map";
import { Translate } from "../../I18N";

const defaultValue = { lat: '', lon: '', label: '' };

function isCoordinateValid(coord) {
  return typeof coord === 'number' && !Number.isNaN(coord);
}

export default class Geolocation extends Component {
  constructor(props) {
    super(props);
    this.latChange = this.latChange.bind(this);
    this.lonChange = this.lonChange.bind(this);
    this.mapClick = this.mapClick.bind(this);
    this.clearCoordinates = this.clearCoordinates.bind(this);
    this.emptyValue = [];
    const { lat, lon } = this.getInputValues();

    this.state = {
      currentLatitude: lat,
      currentLongitude: lon
    };
  }

  onChange(newValue) {
    this.setState({ currentLatitude: newValue.lat, currentLongitude: newValue.lon });
    const { onChange, value } = this.props;

    if (!newValue.lat && !newValue.lon) {
      onChange(this.emptyValue);
      return;
    }

    const valueToSend = value.slice(1);
    valueToSend.unshift(newValue);
    onChange(valueToSend);
  }

  getInputValues() {
    const { value } = this.props;
    const { lat, lon, label } = value && value[0] ? value[0] : _objectSpread({}, defaultValue);
    return { lat, lon, label };
  }

  latChange(e) {
    let latitude = e.target.value ? parseFloat(e.target.value) : '';
    latitude = latitude && latitude < -89.99999 ? -89.99999 : latitude;
    latitude = latitude && latitude > 90 ? 90 : latitude;

    const { label } = this.getInputValues();
    const { currentLongitude } = this.state;
    this.onChange({ lat: latitude, lon: currentLongitude, label });
  }

  lonChange(e) {
    const longitude = e.target.value ? parseFloat(e.target.value) : '';

    const { label } = this.getInputValues();
    const { currentLatitude } = this.state;
    this.onChange({ lat: currentLatitude, lon: longitude, label });
  }

  mapClick(event) {
    const { label } = this.getInputValues();
    this.onChange({ lat: parseFloat(event.lngLat[1]), lon: parseFloat(event.lngLat[0]), label });
  }

  clearCoordinates() {
    this.setState({ currentLatitude: '', currentLongitude: '' });
    const { onChange } = this.props;
    onChange(this.emptyValue);
  }

  render() {
    const { currentLatitude, currentLongitude } = this.state;
    const markers = [];

    if (isCoordinateValid(currentLatitude) && isCoordinateValid(currentLongitude)) {
      markers.push({
        latitude: parseFloat(currentLatitude),
        longitude: parseFloat(currentLongitude)
      });
    }

    return /*#__PURE__*/(
      _jsx("div", { className: "geolocation form-inline" }, void 0, /*#__PURE__*/
      _jsx(Map, {
        markers: markers,
        onClick: this.mapClick,
        height: 370,
        autoCenter: false,
        mapStyleSwitcher: true,
        showControls: true }
      ), /*#__PURE__*/
      _jsx("div", { className: "form-row" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "form-group half-width" }, void 0, /*#__PURE__*/
      _jsx("label", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Latitude")
      ), /*#__PURE__*/
      _jsx("input", {
        onChange: this.latChange,
        className: "form-control",
        type: "number",
        id: "lat",
        value: currentLatitude,
        step: "any" }
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "form-group half-width" }, void 0, /*#__PURE__*/
      _jsx("label", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Longitude")
      ), /*#__PURE__*/
      _jsx("input", {
        onChange: this.lonChange,
        className: "form-control",
        type: "number",
        id: "lon",
        value: currentLongitude,
        step: "any" }
      )
      )
      ),
      (currentLatitude || currentLongitude) && /*#__PURE__*/
      _jsx("div", { className: "clear-field-button" }, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", onClick: this.clearCoordinates }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Clear coordinates")
      )
      )

      ));

  }
}

Geolocation.defaultProps = {
  value: [_objectSpread({}, defaultValue)]
};